import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { connect } from "react-redux";

import Popover from "components/library/Popover";
import Button from "components/library/Button";
import { EDITOR_MODALS } from "config/constants/editor";
import styles from "./PrimaryImagePopover.css";
import shared from "../../../shared.css";

export const PrimaryImagePopover = props => {
  const calculateOffset = isSmall => {
    if (!props.imageElement) {
      return;
    }

    let {
      top: imageTop,
      width: imageWidth,
    } = props.imageElement.getBoundingClientRect();

    imageTop = `${imageTop / 10}rem`;

    return {
      top: isSmall ? `calc(${imageTop} + ${shared["scale-4"]})` : imageTop,
      left: isSmall
        ? // (window center) - (half of image width) which aligns to left of image; divide by 10 to convert to rems
          `calc(${(document.documentElement.clientWidth / 2 - imageWidth / 2) /
            10}rem + ${shared["scale-4"]})`
        : // (window center) + (half of image width) which alignts to right of image
          `calc(${(document.documentElement.clientWidth / 2 + imageWidth / 2) /
            10}rem + ${shared["scale-6"]})`,
    };
  };
  const isActive = () =>
    props.isActive && props.openModal === EDITOR_MODALS.CLOSE;
  const mediaMatch = window.matchMedia(shared["breakpoint-small"]);
  const [matches, setMatches] = useState(mediaMatch.matches);

  useEffect(() => {
    const handler = e => setMatches(e.matches);

    mediaMatch.addListener(handler);

    return () => mediaMatch.removeListener(handler);
  });

  return (
    <Popover
      isOpened={isActive()}
      position={calculateOffset(!matches)}
      className={classNames("primary-image-popover", styles.root)}
      closeModal={props.closeModal}
    >
      <Button
        className={styles.button}
        destructive
        onClick={e => {
          e.preventDefault();
          props.removePrimaryImage();
        }}
        type="tertiary"
      >
        Delete image
      </Button>
    </Popover>
  );
};

const mapStateToProps = state => {
  return {
    openModal: state.editor.ui.openModal,
  };
};

export default connect(mapStateToProps)(PrimaryImagePopover);

PrimaryImagePopover.propTypes = {
  isActive: PropTypes.bool.isRequired,
  openModal: PropTypes.oneOf(Object.values(EDITOR_MODALS)),
  imageElement: PropTypes.instanceOf(Element),
  closeModal: PropTypes.func.isRequired,
  removePrimaryImage: PropTypes.func.isRequired,
};
